import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvcRegistryModalHeaderComponent } from './svc-registry-modal-header.component';

@NgModule({
  declarations: [
    SvcRegistryModalHeaderComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SvcRegistryModalHeaderComponent
  ]
})
export class SvcRegistryModalHeaderModule { }
